import React from "react";
import { Inbox, ShieldCheck, X } from "lucide-react";

export default function MailImportConsentModal({
  open,
  provider = "gmail",
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  const providerName = provider === "outlook" ? "Outlook" : "Gmail";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/55 px-4 py-6">
      <div className="w-full max-w-xl overflow-hidden rounded-2xl border border-emerald-100 bg-white shadow-2xl">
        <div className="flex items-start justify-between gap-4 border-b border-slate-100 bg-emerald-950 px-6 py-5 text-white">
          <div className="flex items-start gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-400/15 text-emerald-200">
              <ShieldCheck size={22} />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-emerald-200">
                Mailbox consent
              </p>
              <h2 className="mt-1 text-xl font-bold">
                Allow {providerName} import for candidate CVs?
              </h2>
            </div>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-full p-2 text-emerald-100 transition hover:bg-white/10"
            aria-label="Close mailbox consent"
          >
            <X size={18} />
          </button>
        </div>

        <div className="space-y-4 px-6 py-5">
          <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
            <div className="flex gap-3">
              <Inbox className="mt-0.5 shrink-0 text-emerald-700" size={20} />
              <div>
                <p className="font-semibold text-emerald-950">
                  RecruitGlance will check recent Inbox messages for the selected job.
                </p>
                <p className="mt-1 text-sm leading-6 text-emerald-900">
                  It looks for job-related PDF CV attachments and stages matching candidates for your review before anything is saved.
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-3 text-sm text-slate-700 sm:grid-cols-2">
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
              <p className="font-semibold text-slate-950">Only recent Inbox emails</p>
              <p className="mt-1 leading-5">Archived or old campaigns are avoided by using your import window.</p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
              <p className="font-semibold text-slate-950">PDF CVs only</p>
              <p className="mt-1 leading-5">Non-CV files and unsupported attachments are skipped.</p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
              <p className="font-semibold text-slate-950">Recruiter approval first</p>
              <p className="mt-1 leading-5">Candidates are saved only after you approve the staged list.</p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
              <p className="font-semibold text-slate-950">You stay in control</p>
              <p className="mt-1 leading-5">You can reject staged candidates and revoke access in Google or Microsoft.</p>
            </div>
          </div>

          <p className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm leading-6 text-amber-900">
            By continuing, you confirm that you are authorized to access and process the candidate CVs in this mailbox for recruitment purposes.
          </p>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-100 bg-slate-50 px-6 py-4 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex min-h-[40px] items-center justify-center rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex min-h-[40px] items-center justify-center rounded-lg bg-emerald-800 px-4 text-sm font-semibold text-white transition hover:bg-emerald-900"
          >
            I agree, continue
          </button>
        </div>
      </div>
    </div>
  );
}
